var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlasses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "ext4_2",
    x: 0.908203,
    width: 40,
    height: 40,
    rx: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1456_168529)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ext4_2_i",
    d: "M29.8632 19.2376C30.0657 19.8751 29.8032 20.5351 29.2857 20.7001C28.7607 20.8651 28.1757 20.4826 27.9732 19.8376C27.7707 19.1926 28.0332 18.5401 28.5507 18.3751C29.0682 18.2101 29.6607 18.5926 29.8632 19.2376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext4_2_i",
    d: "M18.7857 19.2375C18.9882 19.875 18.7257 20.535 18.2082 20.7C17.6832 20.8575 17.0982 20.475 16.8957 19.83C16.6932 19.185 16.9557 18.5325 17.4732 18.3675C17.9982 18.21 18.5832 18.5925 18.7857 19.2375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ext4_2_i",
    d: "M15.4032 25.5C18.0133 25.5 20.2154 23.7618 20.9157 21.3791C21.6159 23.7618 23.818 25.5 26.4282 25.5C29.6024 25.5 32.1732 22.9293 32.1732 19.755C32.1732 18.9659 32.0132 18.2919 31.6627 17.7437C31.3084 17.1896 30.8038 16.8334 30.2407 16.6068C29.1747 16.1777 27.7643 16.17 26.4282 16.17C25.4026 16.17 24.3602 16.1781 23.4744 16.3566C22.746 16.5033 22.0356 16.7824 21.5099 17.3383C21.1162 17.2815 20.716 17.2819 20.3223 17.3392C19.7969 16.783 19.0866 16.5037 18.3583 16.3568C17.4722 16.1781 16.4293 16.17 15.4032 16.17C14.067 16.17 12.6567 16.1777 11.5907 16.6068C11.0275 16.8334 10.523 17.1896 10.1687 17.7437C9.81816 18.2919 9.6582 18.9659 9.6582 19.755C9.6582 22.9293 12.229 25.5 15.4032 25.5ZM26.4207 24.0601C24.1482 24.0601 22.3032 22.2151 22.3032 19.9426C22.3032 17.6701 24.1482 17.6101 26.4207 17.6101C28.6932 17.6101 30.5382 17.6701 30.5382 19.9426C30.5382 22.2151 28.6932 24.0601 26.4207 24.0601ZM15.4032 24.06C13.1307 24.06 11.2857 22.215 11.2857 19.9425C11.2857 17.67 13.1307 17.6603 15.4032 17.6603C17.6757 17.6603 19.5207 17.67 19.5207 19.9425C19.5207 22.215 17.6757 24.06 15.4032 24.06Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1456_168529"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ext4_2_i",
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8.9082 9)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlasses);
export default __webpack_public_path__ + "static/media/Glasses.ddebb89f.svg";
export { ForwardRef as ReactComponent };